import { description_from_message_splitter } from "../../../data/other_constants"

export default (shopify_product_description_html = "") => shopify_product_description_html.split(description_from_message_splitter)[0]
